import React, { PureComponent, useState } from 'react';
import gql from 'graphql-tag';
import { Query, Mutation } from 'react-apollo';
import {
  Form, Grid, Card, Button, StampCard as OriginalStampCard,
} from 'tabler-react';
import { Link } from '@curi/react-dom';
import { IsLoggedIn } from '../auth/Auth';
import { StampCard } from './component';

const ADD_SAVED_SEARCH = gql`
mutation addSavedSearch($name: String!, $searchSettings: String!){
  addSavedSearch(name: $name, searchSettings: $searchSettings) {
    id
    name
    searchSettings
  }
}
`;

const USER_SAVED_SEARCHES = gql`
  query userSavedSearches {
    savedSearches {
      name
      id
      searchSettings
    }
  }
`;

const DELETE_SAVED_SEARCH = gql`
mutation removeSavedSearch($id: ID!){
  removeSavedSearch(id: $id) {
    id
    name
    searchSettings
  }
}
`;

const CardHeader = ({ title, onClick }) => (
  <div role="button" className="card-header" onClick={onClick}>
    <Card.Title>{title}</Card.Title>
    <Card.Options>
      <Card.OptionsItem
        type="collapse"
      />
    </Card.Options>
  </div>
);

function SaveSearch({ searchSettings }) {
  const [name, setName] = useState(null);
  return (
    <Mutation
      update={(cache, { data: { addSavedSearch } }) => {
        const { savedSearches } = cache.readQuery({ query: USER_SAVED_SEARCHES });
        cache.writeQuery({
          query: USER_SAVED_SEARCHES,
          data: { savedSearches: savedSearches.concat([addSavedSearch]) },
        });
      }}
      mutation={ADD_SAVED_SEARCH}
      variables={{ name, searchSettings }}
    >
      {addSavedSearch => (
        <Card className="p-3">
          <Form.InputGroup style={{ height: '2.5rem' }}>
            <Form.Input placeholder="Search Name" onChange={({ target: { value } }) => setName(value)} />
            <Form.InputGroupAppend>
              <Button
                RootComponent="button"
                color="primary"
                href="http://www.google.com"
                onClick={addSavedSearch}
              >
                      Save Search!
              </Button>
            </Form.InputGroupAppend>
          </Form.InputGroup>
        </Card>
      )}
    </Mutation>
  );
}

const confirmDelete = (func) => {
  const shouldDelete = window.confirm('Are you sure you want to delete this search?');
  if (shouldDelete) {
    func();
  }
};

function SavedSearch({
  id, name, searchSettings, currentSearchSettings, onClick,
}) {
  let footer = '';
  try {
    const settings = JSON.parse(searchSettings);
    footer = settings.searchTerm;
  } catch (e) {}

  const currentlySelected = currentSearchSettings === searchSettings;
  return (
    <Mutation
      update={(cache, { data: { removeSavedSearch } }) => {
        cache.writeQuery({
          query: USER_SAVED_SEARCHES,
          data: { savedSearches: removeSavedSearch },
        });
      }}
      mutation={DELETE_SAVED_SEARCH}
      variables={{ id }}
    >
      {deleteSavedSearch => (
        <StampCard
          color={currentlySelected ? 'green' : 'blue'}
          colorHover="red"
          icon="search"
          iconHover="trash"
          header={name}
          footer={`${footer.substring(0, 20)}...`}
          onClick={() => onClick(searchSettings)}
          onStampClick={() => confirmDelete(deleteSavedSearch)}
        />
      )}
    </Mutation>
  );
}

export default class SavedSearches extends PureComponent {
  header = null;

  render() {
    const { searchSettings: currentSearchSettings, onSelectSavedSearch } = this.props;
    return (
      <Query query={USER_SAVED_SEARCHES}>
        {({ data: { savedSearches = [] } = {} }) => (
          <Card isCollapsed ref={header => this.header = header}>
            <CardHeader onClick={() => this.header.handleCollapseOnClick()} title="Saved Searches" />
            <Grid.Row className="p-3">
              {savedSearches.map(({ id, name, searchSettings }) => (
                <Grid.Col key={id} sm={6} lg={3}>
                  <SavedSearch onClick={onSelectSavedSearch} id={id} name={name} currentSearchSettings={currentSearchSettings} searchSettings={searchSettings} />
                </Grid.Col>
              ))}
              <Grid.Col sm={6} lg={4}>
                <IsLoggedIn>
                  {isLoggedIn => (isLoggedIn
                    ? (<SaveSearch searchSettings={currentSearchSettings} />) : (<OriginalStampCard icon="log-in" color="green" header={<Link name="Login">Login Now to Save Searches</Link>} />)
                  )}
                </IsLoggedIn>

              </Grid.Col>
            </Grid.Row>
          </Card>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/archive/savedSearches.js